
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/series/[seriesId]",
      function () {
        return require("private-next-pages/series/[seriesId]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/series/[seriesId]"])
      });
    }
  